<template>
  <div id="contenedor-reportes-main-contrato">
    <v-container
      fluid>
      <v-card
        flat
        class="mb-4 d-print-none">
        <v-card-text>
          <titulo-tool-bar
            v-if="getTituloVentana"
            regresar
            nombreRuta="consultasEstatusContratos"
            :titulo="getTituloVentana.numero">
          </titulo-tool-bar>
          <opciones-tool-bar></opciones-tool-bar>
        </v-card-text>
      </v-card>
      <v-card
        flat>
        <v-card-text>
          <router-view></router-view>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';
import TituloToolBar from '@/components/TituloToolBar.vue';
import OpcionesToolBar from './OpcionesToolBar.vue';

export default {
  name: 'ReportesMainContrato',
  components: {
    TituloToolBar,
    OpcionesToolBar,
  },
  data() {
    return {};
  },
  apollo: {
    contrato: {
      query: CONTRATO,
      variables() {
        return {
          id: this.$route.params.idContrato,
        };
      },
    },
  },
  computed: {
    getTituloVentana() {
      if (!this.contrato) return '';
      return this.contrato;
    },
  },
};
</script>

<style lang="scss">

</style>
